<script lang="ts">
    import type Monster from "../../lib/monster";
    import { getPathFor, getPointCoordinates, inBetween } from "../Attributes/util";
    import type { Point } from "../Attributes/util";
    import { convertNormalizedPath, generateFillColor } from "./util";
    export let monster: Monster;
    export let dimensions: number;
    const normalizedRange = 10;

    const generatePath = (sideLength: number): Point[] => {
        const path: Point[] = [];
        const numPoints = 8;
        let lastPoint: Point;
        const midPoint = { x: (sideLength / 2), y: (sideLength / 2) };

        for (let i = 0; i < numPoints; i++) {
            const radius = sideLength;
            const { x, y } = getPointCoordinates(radius, i, numPoints);
            const coordFromOrigin = { x: x + (sideLength / 2), y: y + (sideLength / 2) };
            if (lastPoint) {
                const midway = inBetween(lastPoint, coordFromOrigin);
                const midwayPulledIn = inBetween(midway, midPoint);
                path.push({ x: midwayPulledIn.x, y: midwayPulledIn.y });
            }
            lastPoint = coordFromOrigin;
            path.push(coordFromOrigin);
        }

        const midway = inBetween(lastPoint, path[0]);
        const midwayPulledIn = inBetween(midway, midPoint);
        path.push({ x: midwayPulledIn.x, y: midwayPulledIn.y });

        return path;
    };
</script>

{#if dimensions}
    <path
        d={getPathFor(generatePath(dimensions))(
            { x: dimensions / 2, y: dimensions / 2 },
            normalizedRange
        )}
        stroke="black"
        fill={generateFillColor('luck', monster)}
    />
{/if}

<style>
</style>
